import { render, staticRenderFns } from "./BulkSchemaMapping.vue?vue&type=template&id=3e40a00e&scoped=true&"
import script from "./BulkSchemaMapping.vue?vue&type=script&lang=ts&"
export * from "./BulkSchemaMapping.vue?vue&type=script&lang=ts&"
import style0 from "./BulkSchemaMapping.vue?vue&type=style&index=0&id=3e40a00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40a00e",
  null
  
)

export default component.exports